<template>
  <div>
    <!-- <van-nav-bar
      title="浪加 用户协议"
      	style="background:linear-gradient(to right,#19CBDA,#2EDD9C);color:#fff;position: fixed;top:0;width:100%"
    >
    <template #left>
      <van-icon name="arrow-left" @click="onClickLeft" color="#fff" size="18" />
    </template>
    </van-nav-bar> -->
    <div class="content">
    <div class="text">
      <h2 class="title">浪加 用户协议</h2>
        <p class="tip">尊敬的用户：
          非常感谢您注册使用 浪加 产品，为让您更好地使用 浪加 提供的产品和服务，请您务必审慎阅读、充分理解《 浪加 用户协议》（以下称「用户协议」或 「本协议」）各条款内容，特别是免除或者限制责任的条款，并选择接受或不接受。本协议中限制、免责条款可能以加粗形式提醒您注意。

          除非您已阅读并接受本协议所有条款，否则您无权下载、安装或使用 浪加 提供相关产品和服务。您的下载、安装、使用、登陆等行为即视为您已阅读并同意本协议的约束。
        </p>
    </div>
    <div class="text" v-for="(item,index) in text" :key="index+'a'">
        <h2 class="title">{{item.tit}}</h2>
        <ul class="texts">
          <li v-for="(it,i) in item.texts" :key="i+'b'">{{it}}</li>
        </ul>
    </div>
    <div class="text">
        <h2 class="title">{{text2.tit}}</h2>
        <ul class="texts">
          <li v-for="(it,i) in text2.texts" :key="i+'c'" v-html="it">{{it}}</li>
        </ul>
        <div v-for="(it,i) in text3" :key="i+'d'">
          <p class="title">{{it.tit}}</p>
          <ul class="texts">
          <li v-for="(it,i) in it.text" :key="i+'e'" v-html="it">{{it}}</li>
        </ul>
        </div>
    </div>
    <div class="text">
        <h2 class="title">{{jifen.title}}</h2>
        <p class="title">{{jifen.tit}}</p>
        <ul class="texts">
          <li v-for="(it,i) in jifen.text" :key="i+'f'">
            <strong style="color:#222">{{it.tit}}</strong>
            <p v-for="(iten,i) in it.text" :key="i+'g'">{{iten}}</p>
          </li>
        </ul>
        <div>
          <p class="title">{{jifen.text2.tit}}</p>
          <p>{{jifen.text2.text}}</p>
          <div>
            <p>{{jifen.text2.text1.tit}}</p>
            <ul class="texts">
              <li v-for="(it,i) in jifen.text2.text1.text" :key="i+'h'">{{it}}</li>
            </ul>
          </div>
        </div>
    </div>


    <div class="text">
        <h2 class="title">{{zsys.zs.tit}}</h2>
        <ul class="texts">
          <li v-for="(it,i) in zsys.zs.text" :key="i+'i'">{{it}}</li>
        </ul>
        <h2 class="title">{{zsys.ys.tit}}</h2>
        <ul class="texts">
          <li v-for="(it,i) in zsys.ys.text" :key="i+'j'">{{it}}</li>
        </ul>
        <strong class="title5-4">{{zsys.ys5.tit}}</strong>
        <ul class="texts">
          <li v-for="(it,i) in zsys.ys5.text" :key="i+'k'"><strong style="color:#222">{{it}}</strong></li>
        </ul>
        <p>{{zsys.text5}}</p>
        <p class="title">{{zsys.text6}}</p>
    </div>
    <div class="text">
      <h2 class="title">{{text6.title}}</h2>
      <p class="title">{{text6.tit}}</p>
      <ul class="texts">
        <li v-for="(item,i) in text6.text" :key="i+'l'" v-html="item">
        {{item}}
        </li>
      </ul>
      <ul class="texts">
        <li v-for="(item,i) in text6_4" :key="i+'m'">
          {{item}}
        </li>
      </ul>
    </div>
    <div class="text">
      <p class="text-6">{{text_6.tit}}</p>
      <h4 class="title">{{text_6.tit1}}</h4>
      <ul class="texts">
        <li v-for="(item,i) in text_6.text" :key="i+'n'">
        <strong style="color:#222">{{item}}</strong>
        </li>
      </ul>
    </div>
    <div class="text"> 
      <p class="title">6.6 用户注销</p>
      <p>
        如果您已经深思熟虑，确定放弃您的 浪加 账户，并符合 浪加 规定的所有注销条件，您可以通过客服热线或者app的意见反馈联系注销。浪加 账户一旦被注销将不可恢复，请您在操作之前自行备份 浪加 账户相关的所有信息和数据，因您的账户申请注销对您造成的不利影响， 浪加 将不承担任何责任。
      </p>
    </div>
    <div class="text">
      <h2 class="title">7. 浪加 使用规范</h2>
      <ul class="texts">
      <li v-for="(item,index) in text_7" :key="index+'o'">
        {{item}}
      </li>
    </ul>
    <ul class="texts">
      <li v-for="(item,i) in text_7_3" :key='i+"p"'>
        <pre>{{item}}</pre>
      </li>
    </ul>
    </div>
    <div class="text" v-for="(item,i) in text_7_" :key="i+'q'">
      <p class="title">{{item.tit}}</p>
      <ul class="texts">
        <li v-for="(it,index) in item.text" :key="index+'r'" v-html="it">{{it}}</li>
      </ul>
    </div>
    <div class="text">
      <h2 class="title">{{text_8.title}}</h2>
      <p class="title">{{text_8.tit1}}</p>
    </div>
    <div class="text" v-for="(item,i) in text_8_2" :key="i+'s'">
      <p class="title">{{item.tit2}}</p>
      <ul class="texts">
        <li v-for="(it,index) in item.text" :key="index+'t'"><strong style="color:#222">{{it}}</strong></li>
      </ul>
    </div>
    <div class="text">
      <p class="title">{{text_8.tit4}}</p>
      <p class="title">{{text_8.tit5}}</p>
    </div>
    <div class="text">
      <h2 class="title">{{text_9.title}}</h2>
      <span>{{text_9.tit1}}</span>
      <ul class="texts">
        <li v-for="(item,i) in text_9.text" :key="i+'u'">{{item}}</li>
      </ul>
      <span>{{text_9.tit2}}</span>
      <span v-html="text_9.tit3">{{text_9.tit3}}</span>
      <span>{{text_9.tit4}}</span>
    </div>
    <div class="text" v-for="(item, index) in text_10" :key="index+'v'">
      <h2 class="title">{{item.tit}}</h2>
      <ul class="texts">
        <li v-for="(it,i) in item.text" :key="i+'w'" v-html="it">{{it}}</li>
      </ul>
    </div>
    </div>
  </div>
</template>
<script>
export default {
  name:'Protocol',
  data(){
    return{
      text:[
        {
          tit:'1. 协议的范围',
          texts:[
            '1.1 浪加是由青岛英派斯健康科技股份有限公司（以下称「 浪加 」或「我们」）提供的互联网产品和服务。'
            ,'1.2 本用户协议是用户（您）与 浪加 之间关于使用 浪加 提供的产品和服务所订立的协议，本协议条款的效力及于 浪加 所提供的一切产品和服务，用户在享受 浪加 任何单项服务时，应当受本协议的约束。'
            ,'1.3 本协议项下的产品和服务是指由 浪加 发布的包括但不限于网络媒体、互联网增值、互动娱乐、电子商务、智能硬件和广告等的互联网产品和服务（形式包括但不限于在线视频、评论、跟帖、弹幕、图片、软件、技术代码等）。'
            ,'1.4 本协议内容同时包括《隐私政策》及所有 浪加 已经发布或未来可能发布的各类规则、公告或通知，且您在使用 浪加 某一特定产品或服务时，可能会另有单独的协议、相关服务规则等，前述规则、公告、通知和协议一经发布即为本协议不可分割的组成部分，您同样应当遵守。如您不同意本协议的约定，您应立即停止注册/激活并停止使用 浪加 的相关产品和服务。'
            ,'1.5 浪加 有权根据需要不时地修订本协议及/或各类规则（包括但不限于制定新的条款和修改既有条款），无须另行单独通知您，如有必要，修改会以通知形式发布于报刊或网站等。修订后的协议和规则一经公布，立即或在公告明确的特定时间自动生效。若您在前述公告修订后继续使用 浪加 的产品或服务，即视为您已阅读、理解并接受经过修订的协议和规则。若您不同意修订，应当立即停止使用 浪加 提供的产品和服务。'
            ,'1.6 除本协议明确规定外，对于利用 浪加 开发/发布的产品和服务， 浪加 有权在本协议的基础上通过单独的产品和服务协议（以下称「单项产品协议」）加以规范，用户须在使用有关产品或服务时另行了解与确认。单项产品协议与本协议有冲突的地方，以单项产品协议为准。如用户使用该产品或服务，即视为对相关单项产品协议的接受。'
          ]
        }
      ],
      text2:{
        tit:'2. 浪加 产品及服务简介',
        texts:[
          '2.1 浪加 为用户提供多样的互联网产品和服务，包括但不限于训练课程、骑行、电商等相关产品，用户可以通过 浪加 产品使用、分享、购买 浪加 提供的产品和服务。用户有权获得 浪加 提供的产品和服务，但 浪加 有权收取由此产生的服务或产品费用。'
          ,'<strong style="color:#222">2.2 浪加 将尽力提供畅通无阻的在线服务，但平台的网络接入服务可能受多种因素的影响出现链接受阻、受限或被终止，由此给您带来的损失、不便，我们将不负任何责任。</strong>'
          ,'2.3 浪加 仅提供在线产品和服务，除此之外与网络服务有关的设备（如手机、个人电脑、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由用户自行负担。'
        
        ]
      },
      text3:[{
        tit:'2.4 浪加 的替换、修改和升级：',
        text:['2.4.1 为增进用户体验、完善服务内容， 浪加 有权根据您对软件的使用状态和行为开发新的服务；',
        '2.4.2 为改进、增强和进一步开发服务，浪加 有权不时提供软件更新（包括软件升级替换、修改、功能强化、版本升级等形式；',
        '2.4.3 用户理解并同意：浪加 有权不向您特别通知而对 浪加 进行更新，或对 浪加 的部分功能进行改变或限制。',
        '2.4.4 浪加 新版本发布后，旧版本可能无法使用。 浪加 不保证旧版 浪加 及相应的服务继续可用。为充分、及时使用 浪加 的服务，请您随时核对并下载最新版本。'
        ]
      },
      {
        tit:'2.5第三方应用及服务',
        text:['浪加 产品中提供了支持第三方应用供用户使用的功能模块，包括但不限于工具类服务、视频或图片类服务等，以及今后可能出现的各种服务。用户在使用该类应用程序时，应遵守本协议及该应用程序相应的协议、条款或规则的规定。用户与开发者之间的权利义务，参照相关协议、条款或规则执行。用户在使用第三方提供的软件和服务时，须了解并同意：',
        '2.5.1 用户使用第三方开发者提供的应用与服务时，第三方开发者将根据用户授权获得用户的个人资料和内容信息。这些资料和信息由用户自行决定授权给第三方。<strong style="color:#222">用户须明确：您向第三方授权获得您个人资料和内容信息的行为，可能发生的信息泄露的风险；您在使用第三方服务的同时，除遵守本协议及 浪加 的其他相关规则外，您还应遵守第三方的协议、相关规则。如因第三方软件及相关服务产生的争议、损失或损害，由您自行与第三方解决， 浪加 对此不承担责任。</strong>',
        '<strong style="color:#222">2.5.2 浪加 引入第三方服务的目的在于丰富 浪加 产品，从而给用户创造更好的服务体验。但因第三方服务出现的瑕疵或错误而产生的责任，由第三方自行承担，与 浪加 无关。当然，浪加 会对第三方提供的服务进行审查或审核，但基于服务的专业性，难免存在遗漏。第三方服务商并不因 浪加 的审查或审核疏漏而免于责任承担。</strong>',
        '2.5.3 浪加 对第三方开发者提供的应用享有审核管理权，有权在不通知用户的情况下，对第三方应用进行下架处理，由此给用户带来的影响、损失， 浪加 将不承担责任，由用户自行承担或与第三方协商，但 浪加 将尽力保障用户权益不受侵犯。',
        '<strong style="color:#222">2.5.4 用户使用第三方应用时，须同意：（1）授权使用自己的 浪加 账号登陆第三方应用；（2）同意第三方应用获取自己的个人资料，以获得相应产品和服务。</strong>',
        '2.5.5 用户因使用第三方应用而与该第三方开发者产生的任何纠纷，由用户与开发者自行协商解决，相关责任和赔偿由开发者单独承担， 浪加 不承担任何责任。'
        ]
      }],
      jifen:{
        title:'3. 积分商城',
        tit:'用户通过使用浪加可以获取一定积分并使用积分兑换商品。',
        text:[
          {
            tit:'3.1商品信息',
            text:['商品价格、数量、性能介绍、是否有货等商品信息随时都有可能发生变动， 浪加 不作特别通知，请用户至商品页面自行查看。我们会尽最大努力保证您所浏览的商品信息的准确性，但由于商品种类繁多且商品信息的数量较大，加之互联网技术因素等客观原因存在，本站显示的信息可能会有一定的滞后性或差错，对此情形请您知悉并理解。 浪加 欢迎纠错，并会视情况给予纠错者一定的奖励。']
          },
          {
            tit:'3.2 订单',
            text:[
              '3.2.1 在您兑换商品时，请仔细确认商品的名称、价格、数量、型号、规格、尺寸、收货人、电话、收货地址等信息。收货人与您本人不一致的，收货人的行为和意思表示视为您的行为和意思表示，您应对收货人的行为及意思表示的法律后果承担连带责任。您提交订单即表示对订单中所确认的商品、收货地址等信息的准确性负责。如果因为您填写的收货人联系电话、地址等信息错误，导致我们（或我们委托的配送公司）将货物交付给非您本意的收货人的，由此造成的损失需由您自行承担。',
              '3.2.2 由于市场变化及各种以合理商业努力难以控制的因素的影响，如您拟购买的商品，在任何购买环节发生缺货或无货，您有权取消订单。',
              '3.2.3 关于支付形式、商品退换货、售后服务等相关问题，可以致电或者通过app意见反馈联系我们，我们的客服人员会及时与您取得联系并帮助您解决问题。'
            ]
          }
        ],
        text2:{
          tit:'3.3 配送',
          text:'3.3.1 我们将会把商品（货物）送到您指定的收货地址，所有在本站上列出的以及客服告知的送达时间为参考时间，参考时间的计算是在综合考量库存状况、正常的处理过程和送货时间、送货地点的基础上估算得出的。参考时间可能与实际送达的时间有所出入，请您知悉并理解。',
          text1: {
            tit:'3.3.2 因如下情形造成订单延迟或无法配送等， 浪加 不承担延迟配送的责任：',
            text:[
              '（1）因用户提供的信息错误、地址不详细等原因导致的；',
              '（2）货物送达后无人签收，导致无法配送或延迟配送的；',
              '（3）情势变更因素导致的；',
              '（4）不可抗力因素导致的，例如：自然灾害、交通戒严、突发战争等。'
            ]
          }
        }
          

      },
      zsys:{
        zs:{
          tit:'4. 知识产权声明',
          text:[
            '4.1 浪加 依法享有 浪加 产品的一切合法权属（包括但不限于知识产权及所有权）。 浪加 的全部著作权及其他一切知识产权，以及与 浪加 相关的所有信息内容，包括但不限于：文字表述及其组合、图标、图饰、图标、色彩组合、界面设计、版面框架、有关数据、印刷材料、或电子文档等均受中国知识产权相关法律法规和有关的国际条约的保护。',
            '4.2 浪加 产品及通过 浪加 产品提供的视频、游戏、技术软件等产品和信息，除用户自己上传或明确标示由第三方提供的之外，全部权利归属于 浪加 。',
            '4.3 浪加 产品中所体现的「浪加」、「DearBike」、「DearRower」和/或 其他浪加 产品和服务标识均属于 浪加 在中国或其他国家、地区的商标或者注册商标，用户未经合法授权不得自行使用。',
            '4.4 浪加 在涉及 浪加 产品及相关各项服务中拥有专利权、专利申请权、商标权、著作权及其他知识产权。 浪加 并未因为本协议或者因为向用户提供 浪加 以及相关产品和服务而授予用户任何与 浪加 相关的知识产权。本协议未明确授予用户的权利均由 浪加 保留。'
          ]
        },
        ys:{
          tit:'5. 用户隐私制度',
          text:[
            '5.1 保护用户个人信息是 浪加 的一项基本原则。 浪加 将按照本协议及《隐私政策》的规定收集、使用、储存和分享您的个人信息。本协议对个人信息的保护规定与《隐私政策》有相冲突的，及本协议对个人信息保护相关内容未作明确规定的，均应以《隐私政策》的内容为准。',
            '5.2 您在注册账号或使用 浪加 产品和服务的过程中，可能需要填写一些必要的信息。若国家法律法规有特殊规定的，您需要填写真实的身份信息。若您填写的信息不完整，可能无法使用 浪加 的产品或服务，或在使用过程中受到限制。',
            '5.3 您可以随时浏览、修改自己提交的信息，但出于安全性和身份识别（如账号申诉服务）的考虑，您可能无法修改注册时提供的部分初始注册信息及其他验证信息。 浪加 保留您修改个人信息的审核权。'
          ]
        },
        ys5:{
          tit:'5.4浪加不会将您的个人信息转移或披露给任何非关联的第三方，除非：',
          text:[
            '（1）相关法律法规或法院、政府机关要求；',
            '（2）为完成合并、分立、收购或资产转让而转移；',
            '（3）事先获得您的授权；',
            '（4）您使用共享功能；',
            '（5）以学术研究或公共利益为目的；',
            '（6）在法律法规和政策允许的范围内，为提升用户体验和提供个性化的推广服务；',
            '（7）我们认为必要且不违反法律强制性规定的其他情形。'
          ]
        },
        text5:'5.5 除非经过您的同意，否则我们不会向任何人提供您的敏感个人信息。',
        text6:'5.6 浪加 非常重视对未成年人信息的保护。若您是18周岁以下的未成年人，在使用 浪加 的服务前，您请在父母或监护人监护、指导下共同仔细阅读并理解本用户协议，并在征得您的父母或监护人同意的前提下使用我们的服务或向我们提供信息。如因您违反法律法规、本协议内容，则您及您的监护人应依照法律规定承担因此而导致的一切后果。',
      },
      text6:{
        title:'6. 用户的账号、密码和安全性',
        tit:'6.1 注册资格',
        text:[
        '您确认，在您完成注册程序或以其他 浪加 允许的方式实际使用 浪加 提供的产品和服务时，<strong style="color:#222">您应当是具备完全民事权利能力和完全民事行为能力的自然人、法人或其他组织。若您不具备前述主体资格，则您及您的监护人应承担因此而导致的一切后果，且 浪加 有权注销或永久冻结您的账户，并保留向您或您的监护人索取赔偿的权利。</strong>',
        '<strong style="color:#222">18周岁以下的未成年人等非完全民事行为能力人应该在法定监护人的指导下使用 浪加 的产品和服务。</strong>',
        '6.2 注册与账户',
        '6.2.1 为完整使用 浪加 提供的产品和服务，您须注册 浪加 提供的账户。用户（您）注册 浪加 账户时须对所提供信息的真实性、合法性、有效性及完整性负责，并及时维护和更新您的个人信息，以保证信息的真实、合法和有效。',
        '6.2.2 您在 浪加 中的注册账号所有权及有关权益均归公司所有，您完成注册手续后仅享有该账号的使用权。您的账号仅限于您本人使用，未经 浪加 书面同意，禁止以任何形式赠与、借用、出租、转让、售卖或以其他方式许可他人使用该账号。如果 浪加 发现或者有合理理由认为使用者并非账号初始注册人， 浪加 有权暂时或终止向该注册账号提供服务，并有权注销该账号，而无需向注册该账号的用户承担法律责任。',
        '<strong style="color:#222">6.3 浪加 在此特别提醒您务必保护好您的账号及密码，切勿将账号及密码透露给他人。您须自行负责对您的账户和密码进行保密，且须对在您的账户和密码下发生的所有活动（包括但不限于信息披露、信息发布、网上点击同意或提交各类规则协议、网上续签协议或购买服务等）承担责任。 浪加 不能也不会对因您未能遵守本条款规定而发生的任何损失负责。若您发现任何人未经授权使用您的账号及密码，您须立即通知 浪加 。你可以致电提出您的请求。您须理解并同意 浪加 根据您的请求采取行动需要合理时间，对在采取行动前已产生的任何不利后果， 浪加 不承担任何责任。因其他人恶意攻击或您自身原因或其他不可抗因素而导致账号盗窃、丢失、均由您本人承担责任， 浪加 不承担任何责任。</strong>',
        '6.4 您可以对账户设置昵称，您设置的昵称不得侵犯或涉嫌侵犯他人的合法权益。用户承诺设置昵称时遵守以下规定：'
      ]},
      text6_4:[
        '（1）不以党和国家领导人或其他社会名人的真实姓名、字号、艺名、笔名注册；',
        '（2）不以国家机构或其他机构的名称注册；',
        '（3）不注册不文明、不健康名字，或包含歧视、侮辱、猥亵类词语的账号；',
        '（4）不注册易产生歧义、引起他人误解或其它不符合法律规定的账号。',
      ],
      text_6:{
        tit:'如您设置的昵称涉嫌侵犯他人合法权益， 浪加 有权终止向您提供部分或全部软件服务。 浪加 对此不承担任何责任，您将承担因此产生的任何直接或间接损失及不利后果。',
        tit1:'6.5 用户同意授权 浪加 基于下列原因使用用户的信息资源',
        text:[
          '（1）执行软件验证、升级服务；',
          '（2）提高用户的使用安全性或提供客户支持；',
          '（3）应用户特殊要求而提供特定服务时，需要将信息提供给 浪加 或与此相关联的第三方或其他用户；',
          '（4）将各种非个人隐私数据用于商业目的，包括但不限于向第三方提供增值服务、广告、定位广告、营销、联合注册、促销或其他活动等；',
          '（5）应司法机关或政府机关要求；',
          '（6）为提高用户使用体验；',
          '（7）其他有利于用户和 浪加 利益且不违反任何强制性法律法规的情况。'
        ]
      },
      text_7:[
        '7.1 用户须对自己的上网行为负责，包括对自己发表、上传或传送的内容（包括文字、评论、跟帖、弹幕、图片、视频内容、软件产品等）负全部责任。用户须承诺在 浪加 平台上所发布的任何内容均符合中华人民共和国法律、法规、规章以及 浪加 管理规范的规定。 浪加 有权对用户发布的任何不符合管理规定的内容予以删除，且不承担任何责任。',
        '7.2 浪加 致力于营造文明、理性、友善、高质量的社区交流环境。在用户使用评论、跟帖、弹幕等功能时，需按照相关法律法规等的规定进行实名认证，否则，您将无法使用上述功能。在使用评论等相关功能时，您需严格遵守国家相关法律法规的规定。 浪加 在推动跟帖评论等业务发展的同时，不断加强相应的信息安全管理能力，完善跟帖评论自律，切实履行社会责任，遵守国家法律法规，尊重公民合法权益，尊重社会公序良俗。',
        '7.3 用户承诺在使用 浪加 产品和服务（包括但不限于：文字、评论、跟帖、弹幕、图片、视频内容、软件产品等）过程中，应自觉遵守法律法规、社会主义制度、国家利益、公民合法权益、社会公共秩序、道德风尚和信息真实性等“七条底线”要求，不发布、转载、传送含有下列内容之一的内容，否则 浪加 有权自行处理并不通知用户。用户不得发表下列信息：'
      ],
      text_7_3:[
        '（1）反对宪法确定的基本原则的；',
        '（2）危害国家安全，泄漏国家机密；',
        '（3）颠覆国家政权，推翻社会主义制度，煽动分裂国家，破坏国家统一的；',
        '（4）损害国家荣誉和利益的；',
        '（5）宣扬恐怖主义、极端主义的；',
        '（6）宣扬民族仇恨、民族歧视，破坏民族团结的；',
        '（7）煽动地域歧视、地域仇恨的；',
        '（8）破坏国家宗教政策，宣扬邪教和迷信的；',
        '（9）编造、散布谣言、虚假信息，扰乱社会秩序、破坏社会稳定的；',
        '（10）散布、传播淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；',
        '（11）危害网络安全、利用网络从事危害国家安全、荣誉和利益的；',
        '（12）侮辱或者诽谤他人，侵害他人合法权益的；',
        '（13）对他人进行暴力恐吓、威胁，实施人肉搜索的；',
        '（14）涉及他人隐私、个人信息或资料的；',
        '（15）散布污言秽语，损害社会公序良俗的；',
        '（16）侵犯他人隐私权、名誉权、肖像权、知识产权等合法权益内容的；',
        '（17）散布商业广告，或类似的商业招揽信息、过度营销信息及垃圾信息；',
        '（18）使用本网站常用语言文字以外的其他语言文字评论的；',
        '（19）与所评论的信息毫无关系的；',
        '（20）所发表的信息毫无意义的，或刻意使用字符组合以逃避技术审核的；',
        '（21）侵害未成年人合法权益或者损害未成年人身心健康的；',
        '（22）未获他人允许，偷拍、偷录他人，侵害他人合法权利的；',
        '（23）包含恐怖、暴力血腥、高危险性、危害表演者自身或他人身心健康内容的，包括但不限于以下情形：',
        '     1）任何暴力和/或自残行为内容；',
        '     2）任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；',
        '     3）怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容。',
        '（24）其他违反法律法规、政策及公序良俗、干扰 浪加 正常运营或侵犯其他用户或第三方合法权益内容的其他信息。'
      ],
      text_7_3_23:[
        '1）任何暴力和/或自残行为内容；',
        '2）任何威胁生命健康、利用刀具等危险器械表演的危及自身或他人人身及/或财产权利的内容；',
        '3）怂恿、诱导他人参与可能会造成人身伤害或导致死亡的危险或违法活动的内容。',
        '（24）其他违反法律法规、政策及公序良俗、干扰 浪加 正常运营或侵犯其他用户或第三方合法权益内容的其他信息。'
      ],
      text_7_:[
        {
          tit:'7.4 用户使用 浪加 产品与服务时，承诺并遵守以下规定：',
          text:[
            '（1）实施的所有行为均遵守国家法律、法规等规范性文件及 浪加 各项规则的规定和要求，不违背社会公共利益或公共道德，不损害他人的合法权益，不违反本协议的相关规则。',
            '（2）不发布国家禁止的或涉嫌侵犯他人知识产权或其他合法权益的产品或服务信息，不发布违背社会公共利益或公共道德或 浪加 认为不适合在 浪加 上发布的产品或服务信息，不发布其他涉嫌违法或违反本协议及各类规则的信息。',
            '（3）<strong style="color:#222">除用户与 浪加 另有约定，用户不得对 浪加 中的任何数据/资料作商业性利用，</strong>包括但不限于在未经 浪加 事先书面同意的情况下，以复制、传播等任何方式使用 浪加 中展示的所有资料或课程。',
            '（4）不使用任何装置、软件或程序干预或试图干预 浪加 的正常运作或正在 浪加 平台上进行的任何交易和活动。',
            '（5）除法律另有强制性规定外，未经 浪加 明确的特别书面许可，任何单位或个人不得以任何方式非法地全部或部分复制、转载、引用、链接、抓取或以其他方式使用 浪加 产品内的信息内容，否则， 浪加 有权追究其法律责任。'
          
          
          ]
        },
        {
          tit:'7.5经 浪加 书面许可后，用户对 浪加 软件及相关服务的信息和内容的分享、转发等行为，还应符合以下规范：',
          text:[
            '（1）不得对 浪加 软件及相关服务的源网页进行任何形式的任何改动，包括但不限于 浪加 软件及相关服务的首页链接入口，也不得对 浪加 软件及相关服务的源页面的展示进行任何形式的遮挡、插入、弹窗等妨碍；',
            '（2）应当采取安全、有效、严密的措施，防止 浪加 软件及相关服务的信息内容被任何形式进行非法获取；',
            '（3）不得把相关数据内容用于 浪加 书面许可范围之外的目的，进行任何形式的销售和商业使用，或向第三方泄露、提供或允许第三方为任何方式的使用。'
          ]
        },
        {
          tit:'7.6 用户充分理解并同意：',
          text:[
            '（1）用户如果违反前述承诺及规范，产生任何法律后果的，用户应以自己的名义独立承担所有的法律责任，并确保 浪加 免于因此产生的任何损失或增加费用。',
            '（2）用户如果违反法律或本协议规定造成 浪加 被第三人索赔的，用户应全额补偿 浪加 的一切费用（包括但不限于各种赔偿费、诉讼代理费及为此支出的其他合理费用）。',
            '（3）当第三方认为用户发表、上传的内容/产品（包括但不限于视频、图片、文字、应用程序、软件等）侵犯其权利，或国家行政、司法机关的生效法律文书确认您存在违法、侵权行为，或 浪加 基于自身判断，认为您的行为违反国家法律法规的规定或涉嫌违反本协议条款的， 浪加 有权自行决定删除相关信息，并在 浪加 或网站上公示您的涉嫌违法/违约行为及对您采取的措施。',
            '（4）若您发现 浪加 内用户发布的内容（包括但不限于图片、视频、文字作品等）侵犯您的在先权利，您可以拨打客服热线进行举报。',
            `（5）对于用户在 浪加 中上传、发布、存储作品和内容（包括但不限于图片、视频、文字作品等），用户保证其对该等作品享有合法著作权/版权或者相应授权，并且<strong style="color:#222">用户同意授予 浪加 对所有上述作品和内容的在全球范围内的免费、不可撤销的、无限期的、并且可转让的非独家使用权许可</strong>，浪加 有权展示、散布及推广前述内容，有权对前述内容进行任何形式的复制、修改、出版、发行及以其他方式使用或者授权第三方进行复制、修改、出版、发行及以其他方式使用。浪加 可能会将前述作品和内容用于自身的推广或其他合法目的，若您不同意授权给 浪加 使用，还请致电联系我们。`,
            '（6）对于用户在 浪加 上涉嫌违法、违约或侵犯他人合法权利的内容、产品， 浪加 有权不经通知予以删除，且不承担任何责任。'
          ]
        }
      ],
      text_8:{
        title:'8. 免责声明',
        tit1:'8.1 用户理解并同意，在使用 浪加 服务的过程中，可能会遇到不可抗力等风险因素，使服务发生中断、延迟。不可抗力是指不能预见、不能克服并不能避免且对一方或双方造成重大影响的客观事件，包括但不限于自然灾害（如洪水、台风、地震等）、社会事件（如战争、暴动、政府行为）等，出现上述情况时， 浪加 会努力对产品和服务进行修复，但由此给您造成的损失， 浪加 在法律允许的范围内免责。',
        tit4:'8.4 浪加 依据本协议享有处理不法、违规内容、产品或服务的权利，但该权利不构成 浪加 的义务和承诺， 浪加 不保证及时发现并做出相应处理。',
        tit5:'8.5 对于单项产品运营者通过 浪加 向您提供的单项产品或服务，由单项产品运营者独立承担与该项产品或服务有关的全部责任和义务，其他 浪加 对此不承担任何责任和义务。'
      },
      text_8_2:[
        {
          tit2:'8.2 在法律允许的范围内， 浪加 对以下情形导致的服务终端或受阻不承担责任：',
          text:[
            '（1）受到计算机病毒、木马或其他恶意程序、黑客攻击的破坏；',
            '（2）用户或浪加的电脑软件、系统、硬件和通信线路出现故障；',
            '（3）用户操作不当；',
            '（4）用户使用非浪加授权的方式使用本服务；',
            '（5）其他浪加无法控制或合理预见的情形。'
          ]
        },
        {
          tit2:'8.3 用户理解并同意，在使用 浪加 产品和服务的过程中，可能会遇到网络信息或其他用户带来的风险和损害， 浪加 不对任何信息或产品的真实性、适用性、合法性承担责任，也不对因侵权行为给您造成的损害负责。这些风险包括但不限于：',
          text:[
            '（1）来自他人匿名或冒名的含有威胁、诽谤、令人反感或非法内容的信息；',
            '（2）因使用本协议项下产品或服务，遭受他人误导、欺骗或其他导致或可能导致的任何心理、生理以及经济上的损害。'
          ]
        }
      ],
      text_9:{
          title:'9. 产品/服务的变更、中止或结束',
          tit1:'9.1 用户应规范、合法地使用 浪加 及服务，如用户发布违法、违背社会公德或违背本协议约定的信息，或有违反相关法律法规或本协议的行为， 浪加 有权采取以下措施：',
          tit2:'9.2 浪加 有权根据业务发展需要中止、变更、终止 浪加 产品或其部分功能，并有权决定是否（继续）提供 浪加 中的某种产品和服务；对于前述情形， 浪加 并不负有向用户通知的义务。',
          tit3:`9.3 除法律另有规定外，<strong style="color:#222">用户有责任自行备份存储在 浪加 的数据，如用户的服务被终止， 浪加 有权从服务器上永久地删除您在 浪加 的全部相关数据，并不负有向您返还或以任何形式提供前述数据的义务</strong>`,
          tit4:'9.4 您可以在 浪加 软件中开启和使用单项或特定服务。某些单项服务可能需要您同时接受就该服务特别制订的协议或者其他约束您与该项服务提供者之间的规则。 浪加 将以醒目的方式提供这些协议、规则供您查阅。一旦您开始使用上述服务，则视为您同时接受有关单项服务的相关协议、规则的约束。',
          text:[
            '（1）直接删除违反法律法规或本协议的内容；',
            '（2）中止或限制您使用 浪加 及其产品和服务的权利，包括但不限于限制您使用 浪加 部分或全部功能及产品、服务等；',
            '（3）终止您使用 浪加 的权利；',
            '（4）回收您的账号，同时有权禁止您申请或通过其他方式取得新的账号；',
            '（5）依法追究您的法律责任，索取相应损害赔偿金。'
          ]
        },
      text_10:[
        {
          tit:'10. 广告',
          text:[
            '10.1 用户同意 浪加 在提供服务的过程中自行或由第三方广告商向您发送广告、推广或宣传信息；其方式和范围可不经向您特别通知而变更。',
            '10.2 对于 浪加 向您发送、推广的广告信息，用户应当自行判断其真实性、可靠性并为自己的判断行为负责。除法律明确规定外，您因该广告信息而进行的交易或遭受的损失/损害， 浪加 不承担责任。',
            '10.3 用户不得使用未经 浪加 书面许可的方式屏蔽、过滤广告信息。'
          ]
        },
        {
          tit:'11. 适用法律及争议解决方式',
          text:[
            '11.1 本协议签订地为中华人民共和国北京市东城区。',
            '11.2 本协议的成立、生效、履行、解释及纠纷解决，适用中华人民共和国大陆地区法律（不包括冲突法）。',
            `11.3 若您与浪加运营者发生任何纠纷或争议，首先应友好协商解决；协商不成的，<strong style="color:#222">您同意将纠纷或争议提交至北京仲裁委员会在北京仲裁解决。仲裁裁决是终局的，对双方均有约束力。</strong>`
          ]
        },
        {
          tit:'12. 其他规定',
          text:[
            '12.1 如本协议中的任何条款因任何原因部分无效或不具有执行力，不影响本协议中其余条款对双方的约束力。',
            '12.2 本协议条款的标题仅为方便阅读而设，不作为解释本协议条款的依据。',
            '12.3 如需联系我们您可通过 浪加 意见反馈或致电400-618-0099与我们联系;'
          ]
        }
      ]
        
    }
  },
  methods:{
   
  }
}
</script>
<style scoped>
.content{
  border-radius: 10px;
  width: 95%;
  margin: 0 auto;
  padding: 10px 9px;
  background: #fff;
  margin-bottom: 10px;
  margin-top:10px
}
.text{
  background:#fff;
  padding: 0 8px;
}
.tip{
text-indent: 20px;
}
.text p{
  font-size: 14px;
  line-height: 20px;
  color: #999;
  word-wrap:break-all
}
.text p.title{
  font-size:14px;
  font-weight: bold;
  color:#23d3bd
}
.text h2.title{
  font-size:16px;
  font-weight: bold;
  color:#23d3bd
}
.texts li{
  font-size: 14px;
  color: #999;
  word-wrap:break-all
}
.text span{
  font-size: 14px;
  /* line-height: 16px; */
  display: block;
  word-wrap:break-all
}
.title5-4{
  font-size: 14px;
  line-height: 0;
}
.text-6{
  font-size: 16px;
  font-weight: bold;
}
.text h4{
  font-size:14px
}
pre{
  font-family: Avenir,Helvetica,Arial,sans-serif;
  margin:0
}
</style>